// extracted by mini-css-extract-plugin
module.exports = {"list":"index-module--list--3rxEE","item":"index-module--item--6MBMT","number":"index-module--number--3T8Vy"};